import css from "styled-jsx/css";

export default css`
  .Searcher {
    position: relative;
  }
`;
